export default __webpack_public_path__ + "static/media/book-opened@2x.1e44c515.png";